/**
 * Restaurant Configuration
 * This file contains all customizable data for the restaurant website
 */

// Import images
import logo from '../assets/images/logo.png';
import uberLogo from '../assets/images/uber.png';

export const restaurantConfig = {
    // Basic Info
    name: "Royal Indian Cuisine",
    tagline: {
        en: "Tandoori Restaurant",
        pt: "Restaurante Tandoori"
    },

    // Logo image, displayed on header
    logoImage: logo,
    // Light Logo image (for transparent navbar)
    logoImageLight: logo,
    // Restaurant founding year, used on About section
    foundingYear: 2023,

    contact: {
        // TheFork booking widget URL
        theForkBookingUrl: "https://module.lafourchette.com/en_GB/module/374508-80d9e",
        
        // Address (displayed on website and used for Google Maps)
        address: {
            street: "Praça Luis Camões, nº 1",
            city: "Lagos",
            region: "Algarve",
            postalCode: "8600-000",
            country: "Portugal",
            // Combined address for display
            displayAddress: "Praça Luis Camões, nº 1, Lagos, Portugal",
            // Google Maps link (opens Google Maps when clicked)
            googleMapsUrl: "https://maps.google.com/maps?daddr=Praça+Luis+Camões,+nº+1,+Lagos,+Portugal",
            // Coordinates for Google Maps Embed
            coordinates: {
                lat: 37.10079311955232,
                lng: -8.674440383911133
            }
        },
        // Email
        email: "royalindiancuisine2023@gmail.com",
        // Phone
        phone: {
            dialing: "351928159344",
            display: "928 159 344"
        },
        // WhatsApp
        whatsApp: {
            dialing: "351928159344",
            display: "928 159 344"
        },
        // Business Hours
        hours: {
            english: "Open Daily 11AM-10:30PM | Call for reservations",
            portuguese: "Aberto diariamente 11:00-22:30 | Ligue para reservas"
        },
        // Social Media Links
        socialMedia: {
            instagram: "https://www.instagram.com/royalindiancuisine_lagos",
            facebook: "https://www.facebook.com/people/Royal-Indian-Cuisine-Lagos/100094299026602",
            tripadvisor: "https://www.tripadvisor.com/Restaurant_Review-g189117-d24101402-Reviews-Royal_Indian_Cuisine_Lagos-Lagos_Faro_District_Algarve.html",
        },
        // Ratings for display
        ratings: {
            googleMaps: 4.7,
            tripAdvisor: 4.5,
            uberEats: null
        }
    },

    // For backward compatibility with components still using these properties
    address: {
        en: "Praça Luis Camões, nº 1, Lagos, Portugal",
        pt: "Praça Luis Camões, nº 1, Lagos, Portugal"
    },
    email: "royalindiancuisine2023@gmail.com",
    phone: "928 159 344",
    whatsapp: "928 159 344",
    businessHours: {
        en: [
            "Open Daily",
            "Call 928 159 344 for reservations"
        ],
        pt: [
            "Aberto diariamente",
            "Ligue 928 159 344 para reservas"
        ]
    },

    // Social Media
    social: {
        instagram: "https://www.instagram.com/royalindiancuisine_lagos",
        facebook: "https://www.facebook.com/people/Royal-Indian-Cuisine-Lagos/100094299026602",
        tripadvisor: "https://www.tripadvisor.com/Restaurant_Review-g189117-d24101402-Reviews-Royal_Indian_Cuisine_Lagos-Lagos_Faro_District_Algarve.html",
    },

    // Theme - Gold and deep red colors typical of Indian restaurants
    colors: {
        primary: "#C9A961",
        secondary: "#8B0000",
        accent: "#D4AF37",
        background: "#ffffff",
        text: "#333333"
    },

    // Menu Items Configuration - Indian dishes from Royal Indian Cuisine
    menuItems: {
        starters: [{
                name: { en: "Samosas", pt: "Samosas" },
                description: { en: "Triangular pastries filled with vegetables and spices", pt: "Pastéis triangulares recheados com vegetais e especiarias" },
                price: "5.50",
                image: "../assets/images/Menu/samosas.jpg",
                tags: ["VEGETARIAN", "CRISPY", "POPULAR"]
            },
            {
                name: { en: "Pakoras", pt: "Pakoras" },
                description: { en: "Vegetables fried in chickpea flour batter", pt: "Legumes fritos em massa de farinha de grão" },
                price: "5.00",
                image: "../assets/images/Menu/pakoras.jpg",
                tags: ["VEGETARIAN", "CRISPY"]
            },
            {
                name: { en: "Papadums", pt: "Papadums" },
                description: { en: "Thin, crispy lentil crackers served with chutneys", pt: "Finas bolachas crocantes de lentilhas servidas com chutneys" },
                price: "3.00",
                image: "../assets/images/Menu/papadums.jpg",
                tags: ["VEGETARIAN", "CRISPY"]
            },
            {
                name: { en: "Pani Puri", pt: "Pani Puri" },
                description: { en: "Crispy snack stuffed with potato, chickpeas and tamarind sauce", pt: "Snack crocante recheado com batata, grão de bico e molho de tamarindo" },
                price: "5.50",
                image: "../assets/images/Menu/pani-puri.jpg",
                tags: ["TRADITIONAL", "STREET FOOD", "POPULAR"]
            }
        ],
        mains: [{
                name: { en: "Chicken Tikka Masala", pt: "Tikka Masala de Frango" },
                description: { en: "Grilled chicken cubes in a creamy tomato sauce", pt: "Cubos de frango grelhados em molho de tomate cremoso" },
                price: "13.90",
                image: "../assets/images/Menu/tikka-masala.jpg",
                tags: ["CHICKEN", "CREAMY", "POPULAR"]
            },
            {
                name: { en: "Chicken Biryani", pt: "Biryani de Frango" },
                description: { en: "Basmati rice with chicken and aromatic spices", pt: "Arroz basmati com frango e especiarias aromáticas" },
                price: "14.50",
                image: "../assets/images/Menu/biryani.jpg",
                tags: ["CHICKEN", "RICE", "AROMATIC"]
            },
            {
                name: { en: "Tandoori Chicken", pt: "Frango Tandoori" },
                description: { en: "Chicken marinated in yogurt and Indian spices, prepared in clay oven", pt: "Frango marinado em iogurte e temperos indianos, preparado no forno de barro" },
                price: "13.50",
                image: "../assets/images/Menu/tandoori.jpg",
                tags: ["TANDOORI", "CHICKEN", "TRADITIONAL"]
            },
            {
                name: { en: "Prawn Curry", pt: "Caril de Camarão" },
                description: { en: "Prawns in a creamy curry sauce", pt: "Camarão em molho de caril cremoso" },
                price: "16.90",
                image: "../assets/images/Menu/prawn-curry.jpg",
                tags: ["SEAFOOD", "CURRY", "CREAMY"]
            },
            {
                name: { en: "Lamb Rogan Josh", pt: "Cordeiro Rogan Josh" },
                description: { en: "Slow-cooked lamb with tomatoes and spices", pt: "Cordeiro cozinhado lentamente com tomate e especiarias" },
                price: "15.90",
                image: "../assets/images/Menu/lamb-curry.jpg",
                tags: ["LAMB", "CURRY", "RICH"]
            },
            {
                name: { en: "Vegetable Korma", pt: "Korma Vegetariano" },
                description: { en: "Mild and creamy curry with fresh vegetables, coconut milk and nuts", pt: "Curry suave e cremoso com vegetais frescos, leite de coco e castanhas" },
                price: "12.50",
                image: "../assets/images/Menu/veg-korma.jpg",
                tags: ["VEGETARIAN", "MILD", "CREAMY"]
            }
        ],
        sides: [{
                name: { en: "Naan", pt: "Naan" },
                description: { en: "Traditional Indian bread", pt: "Pão tradicional indiano" },
                price: "2.50",
                image: "../assets/images/Menu/naan.jpg",
                tags: ["BREAD", "TRADITIONAL"]
            },
            {
                name: { en: "Garlic Naan", pt: "Naan de Alho" },
                description: { en: "Naan bread with garlic and butter", pt: "Pão naan com alho e manteiga" },
                price: "3.00",
                image: "../assets/images/Menu/garlic-naan.jpg",
                tags: ["BREAD", "GARLIC", "POPULAR"]
            },
            {
                name: { en: "Raita", pt: "Raita" },
                description: { en: "Yogurt with cucumber and spices", pt: "Iogurte com pepino e especiarias" },
                price: "3.00",
                image: "../assets/images/Menu/raita.jpg",
                tags: ["REFRESHING", "YOGURT"]
            },
            {
                name: { en: "Pulao Rice", pt: "Arroz Pulao" },
                description: { en: "Basmati rice flavored with spices", pt: "Arroz basmati aromatizado com especiarias" },
                price: "3.50",
                image: "../assets/images/Menu/pulao-rice.jpg",
                tags: ["RICE", "AROMATIC"]
            }
        ]
    },

    // Team Members
    team: [{
        name: "Royal Indian Cuisine Team",
        role: {
            en: "Master Chefs & Hospitality",
            pt: "Chefs Mestres e Hospitalidade"
        },
        bio: {
            en: "Welcome to Royal Indian Cuisine! Our experienced team brings authentic Indian flavors to Lagos. With years of culinary expertise, we specialize in traditional Tandoori and North Indian cuisine, using fresh spices and time-honored cooking techniques. From our famous Tandoori Chicken to our aromatic Biryani, every dish is prepared with passion and authenticity.",
            pt: "Bem-vindos ao Royal Indian Cuisine! A nossa equipa experiente traz sabores indianos autênticos a Lagos. Com anos de experiência culinária, especializamo-nos na cozinha Tandoori e do Norte da Índia, usando especiarias frescas e técnicas de cozinha tradicionais. Do nosso famoso Frango Tandoori ao nosso aromático Biryani, cada prato é preparado com paixão e autenticidade."
        },
        image: "/images/team/royal_indian_team.jpg"
    }],

    // About Section Content
    about: {
        en: "Located in the heart of Lagos at Praça Luis Camões, Royal Indian Cuisine brings the authentic flavors of India to the beautiful Algarve coast. Our restaurant has been serving traditional Indian cuisine with pride and passion, creating memorable dining experiences for both locals and visitors.\n\n**Our Culinary Heritage**\nAt Royal Indian Cuisine, we honor the rich traditions of Indian cooking. Our skilled chefs prepare each dish using traditional tandoori techniques and premium ingredients, ensuring that every bite delivers the authentic flavors of India. From aromatic curries to tandoori specialties, we bring the vibrant tastes of Indian cuisine to your table.\n\n**The Royal Indian Cuisine Experience**\nFrom our signature Chicken Tikka Masala to our aromatic Biryani that keeps customers returning, we create dishes that tell the story of Indian culinary artistry. Whether you're enjoying spicy curries with family or savoring our tender Tandoori Chicken, every meal at Royal Indian Cuisine is a journey through India's diverse culinary landscape.",
        pt: "Localizado no coração de Lagos na Praça Luis Camões, o Royal Indian Cuisine traz os sabores autênticos da Índia à bela costa algarvia. O nosso restaurante tem servido cozinha indiana tradicional com orgulho e paixão, criando experiências gastronómicas memoráveis tanto para locais como para visitantes.\n\n**A Nossa Herança Culinária**\nNo Royal Indian Cuisine, honramos as ricas tradições da cozinha indiana. Os nossos chefs especializados preparam cada prato usando técnicas tradicionais tandoori e ingredientes premium, garantindo que cada mordida entrega os sabores autênticos da Índia. De caril aromáticos a especialidades tandoori, trazemos os sabores vibrantes da cozinha indiana à sua mesa.\n\n**A Experiência Royal Indian Cuisine**\nDo nosso Chicken Tikka Masala aos nossos aromáticos Biryani que fazem os clientes regressar, criamos pratos que contam a história da arte culinária indiana. Seja a desfrutar de caril picante com a família ou a saborear o nosso tenro Frango Tandoori, cada refeição no Royal Indian Cuisine é uma viagem através da diversa paisagem culinária da Índia."
    },

    // Reviews section - keeping the testimonials as they are real Portuguese reviews that fit the restaurant
    testimonials: [{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": true,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "Aatman Shah",
  "reviewId": "ChZDSUhNMG9nS0VKS0VyX25pZ2FMb1dBEAE",
  "reviewImageUrls": [
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90Cs0SFXHhWwe4jCN7gcGudHeNtD4LeKB9BGI7La8E8KPlaQd9bZ3Q4n0RSyyE_CfNWNpXZWeB3nWQVLBm6Ma0iATGVFHbTvAHCYdkYJ9oxS43TiFkcU1LDDWHFK5RyPe_QJy1E",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90BaOewYtVAoqH2skyoE1Rg2vmvKIuHFf6JQyUU6-CHEcsvsSuOkZCb6G1XpUzTFIkE8Yfv2gP0FTkDT59PgqB4JRVMnG3jRGsVrz6siH0F2AtrZvzmLYI-RRytsYLQtVjJ11kt5",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90C-Ps693e5I3PnIPKV0JNOHC5B3uKRrxlvfQBvbOp2MNe3ZOr2ZW9-Yt9bhOCzTWe5jsl19IkDy6Rq_EhnalQpJTkWadDCSOmQDdv8jcBs0pZHfsfytvJooyt4I0Qk81qcZXg",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90BDsNdVlytexdhlPHQ4yDJMdqy4cPtGGiJHHj0_Tm7TXKJhXnPmEbgIeWodEiuv0tFLO3G9EO0u-V_sbRtmXvUsvtPc_epGzIH_XoMdkAiYkYx0X0b3DCCbfYiFBKAaoTXR9z8",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90AMI4rjfLXk8zKgtjvtP2b9q_QbwGaYyX3693gECuCw0Wau4Qro4hs42cn3Px2HSQSg5e8j8JQT1sEap49Kls9nxJhKtb4kG1HbpUgYG61zV9mv0tIEjbUvau_SzHyGiX9KSwI",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90DjMpVs7fEnvWhHC6vtqVBxcAUXdXgZpZOlq1thLh2tddjbQVM7kEjkkK6Ysr6iTuSX6546bRsFPRgTIudk3pwfwVDtierudlyyzm0f29bFRKzLKnFUnJKuOeoMlLAP7RRmMcbd",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90Aj0R1kvq6CmJFBsJdMzbUeRarouqg70KF7hyoObNk44PHBrXCWvH4eNyrUAWxhkyVRkhsd_YDmhYXUVvg312zS4F2tlV95gxbbCXe2ZVqwXckFyr6U_Tho05iF8B3RugCjgWSntg"
  ],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChZDSUhNMG9nS0VKS0VyX25pZ2FMb1dBEAE!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CIHM0ogKEJKEr_nigaLoWA%7CCgwI-4aEwQYQkNDGlwM%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a/ACg8ocLPSxx_VA6AAa-MJU-KmEw9EQse3mMmFt3PQzg-vJq5jK9bwg=s1920-c-rp-mo-ba4-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "Great place for Indian food with authentic Indian taste and this is also a genuinely Indian owned Indian restaurant. Most of Europe we rarely find Indian owners. Generally they only use the names.\nArjun also help with special requests on Jain food and helped my friend and made our day.\nTaste was great, fresh food, fresh paneer.\nStarters were also best tasting including Samosa.\nSahi Paneer was not very sweet so even better.\nForgot to take pictures of food before we started eating so what you see here is not full dishes."
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": true,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "Matt Bearman",
  "reviewId": "Ci9DQUlRQUNvZENodHljRjlvT210NVJrSmlXRFZsVkRBNGMwbEhkRkJtVDNZM1JIYxAB",
  "reviewImageUrls": [
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90CA3_ka8iRhCg2wkdRJ6FoGZKLcgWfz_X0-dni5XaxNs0F5MG_390pSl2e3hULxD2VhN2SAh4g7kwXIQTeOqjnuohF4RtqXV2mPuVaMhkUgA7TSiJns3muQINkSsCKGnuQKD4Lr07wfvMg",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90AGLq9TYcdUYy5fwwtMmSW6wKnbHSekguZbwXIjAHoe4oriL0_W0Y98JaPm7w0YUaDPpMB8K-S2eBKCVQH2nZgv-fgXb1KDjA1I63OEqIkBSjqdmrL5kO16UHb5ww0CfqSjl5Wfv5B_sqTO",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90DI79ag4HGnUka5NluYeAXwo9JTD8ZKM7amNzfF6Ad9qhehelbFG4o5u6Y8YS9fajwAVWk2Cc16XDhm7uHa8rRBOa-Mnr0eL04zGu5UE6YGAGmOJJ1j1Ajuo6bS7p92aqY3HgW7GcwmASPj",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90AdG2dzazs6bMd8iJ60-qEbW3xJdn7KChBhFXIGmT3fw8BDqWm08b6wB9m2G1-bx-E9cL9fWCFuIgKa_V2G4aD2piqBKf-X4PWTPu2xGTWp5kcdD4945wJAAalcxuy2Tnr1vABCbbql6XfY",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90BbWDuIxjlg3NgxBGyZBMV-g8h8KbCCVK-6BmwXYSNlwrByUlv2FV6hxLj8z_NHSTB4JePj7p-odY2JsM88Xc6NupTrIq_3qC7TXwPR1umyHhru26xsZVxDEOV04j1Mkebl1SzkfCVhLeQ",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90B0ZPTgK4csRr7ykJWP3EP78ym-cQu5sWRo5i3v5FQI-Fr7KQ7kpvGjAKKL_Cx44nt9nfopl82JbkOl38UMv1og28Tm9XMPjBwpHxrcaUy9WPruS75luzCd_WoCFCOQzl-SVZKiaspEFirI",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90CBxyyIM3drYv8GBtjDSsdcwVnxJWgOA09FkBm2bspkOlrgkyUGMrJqFY8pckU8agvsjVuwODVtSQH-bCMdFFYBLZBoX5PAvESeGwTOrv02vmMXdF49kdDD_iOBFTp5JUMd4z3WFLmQVjo"
  ],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT210NVJrSmlXRFZsVkRBNGMwbEhkRkJtVDNZM1JIYxAB!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CAIQACodChtycF9oOmt5RkJiWDVlVDA4c0lHdFBmT3Y3RHc%7C0cH7xlVyh0z%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a/ACg8ocLB2TJ9sTXLtTg1V_h9kTM3PAtIf4254fxgEMvMCzzpjLhdmQ=s1920-c-rp-mo-ba3-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "One word... Wow!\nProbably one of the tastiest curry experiences ever. Had a chicken dansak, tikka masala, with garlic naan bread, and pilau rice. Flavours slighty different to UK, but arguably better! Definitely worth trying. After reading the reviews I wanted to try the Mango Lassi (omg this is amazing too. Mango and yogurt drink with nuts served in a goblet 😬)\nVery friendly team, great indoor atmosphere too."
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": true,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "Nicky Konings",
  "reviewId": "Ci9DQUlRQUNvZENodHljRjlvT25Ob1JIVm1NVVJOTURJeVdXMXpZaTE2ZDBZd1EyYxAB",
  "reviewImageUrls": [
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90CJydXhFwV0HIMFx1Ic9pQgEZkceoB-T8hKjcysuBw1K5RrH3yt1uImZ1ScPioEbznBKUJw8_ow-FKm7WB0vHqPvs2LgkkHg94RtmVzaBrdncCM7f4ivsFKxTLWNaThI577yaPDamI9tdQV",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90BT4Wg8dEjH-bK1gi92g3S4aQVrbrzRQjweBRdalYb8NhPRBPgGEIBNzvaVwMH1lb2AfAHOyWUdSf96xySykAQeugBzPdeE7lcbhPSsRyBR__1bZWf8ohMbc7QOzbR2Vf4VnqBwyAxe6EI8",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90DG9Fs_gkZGlouZU31q7UI7WlZeh2WC91IJKYwh9STm3Ua5Fux_bUnapzKf83wNCWpa0Ob_IyppQBps_42TtoMPayqq3yKEnZsF8I9xluyiio1KHoNmKirXBtElVxaSjllzS37lQ3oESdSq"
  ],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT25Ob1JIVm1NVVJOTURJeVdXMXpZaTE2ZDBZd1EyYxAB!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CAIQACodChtycF9oOnNoRHVmMURNMDIyWW1zYi16d0YwQ2c%7C0ciTWti1DNF%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a/ACg8ocJsnbcSZbGWkTI4RmTiDoTZ8GgmtjGdmRAE2NqlN3RZ4mbULQ=s1920-c-rp-mo-ba3-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "Best Indian food we had since a long time. Exceptionally friendly and helpfull staff. I am vegan and they pulled it off. So many options and the Pani Puri is my personal favorite indian snack. I had the mushroom masala and the biryani which they made vegan for me. Awesome :) definitely I would recommend this place!"
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": false,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "Bayden I.",
  "reviewId": "Ci9DQUlRQUNvZENodHljRjlvT25Wc1pHdHFkbmhyYmxaNVlpMTZMVXN0T0ZKSmFGRRAB",
  "reviewImageUrls": [],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT25Wc1pHdHFkbmhyYmxaNVlpMTZMVXN0T0ZKSmFGRRAB!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CAIQACodChtycF9oOnVsZGtqdnhrblZ5Yi16LUstOFJJaFE%7C0cs3-lqwV7d%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a/ACg8ocL18KOyY6wncbS3BOkw2QLHrTv51fY28WnqL5WOvgjWKkQ9WPTQ=s1920-c-rp-mo-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "The lamb vindaloo is amazing! Kulfi was homemade and fresh! Chicken kharai was delicious and full of flavor. Abbas was our waiter and he went above and beyond with his service. His hospitality made me feel like I was right at home, so good we had to come back the next night. Be sure to ask for Abbas when you come! Owner was very kind and let us in late close to closing time for dessert. 10/10 experience, would come back to Portugal just for Abbas!"
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": true,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "Ian Watts",
  "reviewId": "Ci9DQUlRQUNvZENodHljRjlvT2s4eGNXbE5kMnRTVFZWMU9VNWxWamhpU0U1YVRWRRAB",
  "reviewImageUrls": [
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90B3PHpRUzqWExykQb8etrFE9vdsufH2B5LBYb3xyDmvscRPtmaMOK5h9erIOTznJUiaQbCUHR_Pgi11oU3K5KaEFXHJFICqWs_lgpr-yGmsrq3npCjJenRs4gQJe8oXznTBcXt4c6hC4KOL",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90Cbie3wDgrkEe0Mo2wdC6OxnX0p1kdjyswhYjbdDIbueGNmAmUoVV94PjXLx13zRjj1gtuENMgeqNwZ-gDuO64LU_dhumlmEEb51gcXzVKyNDaR0Pj01PUbrIgCkjmintssu9Zx1IVpzCA6",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90BEmNlPg4cURDzEJjRlAD50Wqao5JsZo6aYJ_eSjax0mc-xWZbtMrH9_9aQT1J0IghvbYD4x7K46yeGoItQ9NrKMO6S05Ar5iqOl8PGhgGQ4GaqLSMkVOqAYjEVwQyj1JGVOqW-cR7UEpSB",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90ApLXpJcx0jpwezkPdipXKPUc3T4i4eWPmQvD7aML6baj3qwvHbKftQUHG8VnLhE31UPLOIj9rgYJ8EbCJV3aSCz6coz76JHJEczwssqENFyVESR8LcqK4SIwN8jygNs_oMIH8QUhI4l46V",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90BBd8c9dw9PR_z4ORk2L_uWLuf9cdan7wN_kIfsOMZ4a-FoS31ny8UxgcQQ4axDqwi_Befj6AsuaUqFuLryV3v5pKtN_s2T1sH0uBV_aVQikRo3Vxo57QnhivrshW153twb4hV75fZxVziA"
  ],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT2s4eGNXbE5kMnRTVFZWMU9VNWxWamhpU0U1YVRWRRAB!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CAIQACodChtycF9oOk8xcWlNd2tSTVV1OU5lVjhiSE5aTVE%7C0cgStJH1spk%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a/ACg8ocJJ5s-mA1_eg3SqXt284ITyabm0IMDti9GZktQkJp65bEgm7g=s1920-c-rp-mo-ba4-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "This is an exceptional Indian restaurant.\nI had a chicken jalfrezi with rice and my wife had a rogan ghosht with naan bread, both were excellent.\nI'll be going back for more!"
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": true,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "Olivia",
  "reviewId": "Ci9DQUlRQUNvZENodHljRjlvT25VM1RVTllXRkJMYmpsSlR5MTFZbmhSVkU0dE5WRRAB",
  "reviewImageUrls": [
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90AYbFr5zzyKHnEgPv37oRfXqExdu7in1xLAV6VDwzFptypLdg4xHr0WRRskXAAbNdE_hOcjkZ1Ywc64hvg7h-eYfFmm0Yek_C9CXNiMrjvIrCSMJgtOj31sTYT1avsNkjn_RxxELU6O7l44"
  ],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT25VM1RVTllXRkJMYmpsSlR5MTFZbmhSVkU0dE5WRRAB!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CAIQACodChtycF9oOnU3TUNYWFBLbjlJTy11YnhRVE4tNVE%7C0cp4lGWmXj6%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a-/ALV-UjU7M0rbtTP-SurPtsDfRmFa4yjABDO4USPHjyWeLQ9lvgEBowo=s1920-c-rp-mo-ba2-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "Best Indian food we have had! Sandhu was a great server and suggested we got the chicken tikka masala and it was 10/10. We will be back!"
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": true,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "Zuzana Horálková",
  "reviewId": "ChZDSUhNMG9nS0VJQ0FnTURvdU9iRFFBEAE",
  "reviewImageUrls": [
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90C68nCK-dDKEITeg4RVwSyL-aia27bAX1-KjZ82UM3fglfAC9WpGDs9pazc3SAW3iyslG9ECiDVcnx6Cn25UyK0ueXt-vBIx4RW229UrtWTSxk3yI-OaoSFbGJ8OdrnTkSzrNi8SQ",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90AI2UO8mi3Ks1sDiHHd6Sx_dg9Czoj7XOuLK0EoMryg0BPKQx8PCpYzQB7YeT94ul7_W__znaPPlBlI9aDP3GH4rKgHHm4CgUG4pyuZBr83btKP01NLzDYjPqw9NBEJ9K69Exk"
  ],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChZDSUhNMG9nS0VJQ0FnTURvdU9iRFFBEAE!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CIHM0ogKEICAgMDouObDQA%7CCgwIk-2awAYQwKCK-gE%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a-/ALV-UjVSccYVRsuxyQs_X9zp_TBrc4iM5s_9XZi3Nu0dBgXHYp5ep7HjoA=s1920-c-rp-mo-ba3-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "We visited the restaurant for dinner and got a menu, priced at €15.90, including  a main dish, a choice of rice or naan, and a scoop of ice cream of our choice. The food was nicely server and delicious. The staff were kind and welcoming, which made the whole experience even more enjoyable 🌸\nThank you!"
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": true,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "Anna-Maria (radam4nt)",
  "reviewId": "Ci9DQUlRQUNvZENodHljRjlvT2xneGIySmFhR3BHVjJaSmVESTBha3ROTVdsamIyYxAB",
  "reviewImageUrls": [
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90AZC0_AnKvVhX-fYXkUs1H33bGAcMwX0D3gg9wqRbjn5qyIBwTLpgMoPB8buyjFtavDZ1y7wLwbNePFH5-muf1KjRKPEeS_Athbyjs7y6_v8HpkBrkCkwFsAEEVHCly6lPsVI9elZCzHz-D"
  ],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT2xneGIySmFhR3BHVjJaSmVESTBha3ROTVdsamIyYxAB!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CAIQACodChtycF9oOlgxb2JaaGpGV2ZJeDI0aktNMWljb2c%7C0cw-0vMA-QR%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a-/ALV-UjXCRbA9S0vS8s-bEFKaf1zl5s5y5vw4XKc5xnrz1gLMNWHTMFuX=s1920-c-rp-mo-ba3-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "Nice and tasty food, good portions, clean and comfortable place. We paid about €37 for a nice amount of food."
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": false,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "Amit Chauhan",
  "reviewId": "ChZDSUhNMG9nS0VJQ0FnTURvemRTeElnEAE",
  "reviewImageUrls": [
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90BYG4J_CcComlBfkudfEqM40OpuOjuWE0ik69xOaUaT4q-E8H7dmweGrJw8baPmHzQFMdPIUyISpeo8QbRYn_7eScGqVh9xwV7iv4g8TKQBJuwOZIILaER_5j-p6OM9FySTVNMb"
  ],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChZDSUhNMG9nS0VJQ0FnTURvemRTeElnEAE!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CIHM0ogKEICAgMDozdSxIg%7CCgwI59-4wAYQ0IOswwE%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a-/ALV-UjUkSqW4yUhz2PzHW_VbSDIn4Td3u9DEMpfg1IfUMqvN0MlEEAa5=s1920-c-rp-mo-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "Wonderful experience at the restaurant. The food was delicious, service was top notch, and the people working there were so hospitable. Highly recommended this one."
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": true,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "Muhamed Ikovic",
  "reviewId": "ChZDSUhNMG9nS0VJQ0FnTUR3NllUUk93EAE",
  "reviewImageUrls": [
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90DR08g1Z81kPUR-mvPjdUWj8eSdf1jzAwojW2wD8dcwt5LYO1D5bzrJpPTjNFwNhJiyWQf_IWvn94vfZSClWxVwIQvKERy-AP3xgYTfhdTNpmK-jML8F0h5BU7wJkkPPDI4O5ZuoA",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90CLlavUZRcUMf3LzIi1I2LslRa05jD5SdGWjqQZTX6aVO8D6wd4kQRlMFRoZkptGR8v5ZTZuUhl1AtuhVEjtC7Gq_J3qF5HV7VsnGR2qhlEY6VI0MmWS0-XztAOSiY9BDkGgT8",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90AnWfksduzWzA3l7sAcxru3qjrBpmevtIFucqKfn4iVhQ01mIEzm-sDtllWYdlDONO9u0F22AqY9hv3WHm9WauVbitDT8XrTaSUluX089heX178mvOpr52KmriWjmv38vI-Bl059w"
  ],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChZDSUhNMG9nS0VJQ0FnTUR3NllUUk93EAE!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CIHM0ogKEICAgMDw6YTROw%7CCgsIxdSRvwYQwMWkDw%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a/ACg8ocLY3HyQUF2rzj3dp7ACgijYn93y1m0jpEOlrWuklPlEVU96vg=s1920-c-rp-mo-ba2-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "Very tasty food, nice and pleasant waiters. The garlic-cheese naan is out of this world!!\n\nThe only thing that I found surprising is that you had to order rice extra, but other than that all fine."
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": false,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "Nick O",
  "reviewId": "Ci9DQUlRQUNvZENodHljRjlvT2tJMk5YRkRSbXd4WlZWRVduRmlRMFUxTVhZeFFWRRAB",
  "reviewImageUrls": [],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT2tJMk5YRkRSbXd4WlZWRVduRmlRMFUxTVhZeFFWRRAB!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CAIQACodChtycF9oOkI2NXFDRmwxZVVEWnFiQ0U1MXYxQVE%7C0csN0aA8Zvr%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a/ACg8ocIFlnaINWM377yETPusxxqqSj91FR5J2LSRsGoYbGmRSAQAaA=s1920-c-rp-mo-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "We had a fantastic dinner here. We ate two of the Chef’s specialities (Fish Madras and Prawn Bhuna), both of which were delicious.\n\nArjun was very friendly and provided good recommendations."
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": true,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "Kyleigh Sloan",
  "reviewId": "ChZDSUhNMG9nS0VOREVwb0xZd29IaVZBEAE",
  "reviewImageUrls": [
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90CL8LZ3roxoGw_fcBO7wumyvj69eEPLL2nxzzRF3g10yaLVk52ClVjqoHGYLiaiI5mfnZY_itljPtGiShMwjE_Q3L4igcbsrOp65lQfyaayli08cLcED6asq11unBSOJgcd7V4VGg"
  ],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChZDSUhNMG9nS0VOREVwb0xZd29IaVZBEAE!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CIHM0ogKENDEpoLYwoHiVA%7CCgwI_-uSwQYQkPDwwAI%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a-/ALV-UjX4xtGbOE4tWwQqtq3btLePgU9F7Wr-zeUB2BFewnVsmqJ26Ml8=s1920-c-rp-mo-ba3-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "Absolutely delicious, best Indian food I’ve ever had. Abbas recommended caprinha, wonderful!"
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": false,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "edna villafan",
  "reviewId": "Ci9DQUlRQUNvZENodHljRjlvT2twRldtbExRbEJrV0VOSldHMXhWRTVhV2xKRFVGRRAB",
  "reviewImageUrls": [],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT2twRldtbExRbEJrV0VOSldHMXhWRTVhV2xKRFVGRRAB!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CAIQACodChtycF9oOkpFWmlLQlBkWENJWG1xVE5aWlJDUFE%7C0crOPzoEjo2%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a/ACg8ocKbCTfvljoYW1VZ9Sllf3iVT7taYDmDocdrfHcpzPV_FsRcHQ=s1920-c-rp-mo-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "Great food. Asked for spicy and they executed my request. Highly recommend this restaurant to anyone that loves full and bold flavors . The ambience was wonderful."
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": true,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "Candace Romero",
  "reviewId": "Ci9DQUlRQUNvZENodHljRjlvT2xaeGNsSmtZM2R0ZURVeU9XOW1iR3hDY0RaM0xYYxAB",
  "reviewImageUrls": [],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT2xaeGNsSmtZM2R0ZURVeU9XOW1iR3hDY0RaM0xYYxAB!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CAIQACodChtycF9oOlZxclJkY3dteDUyOW9mbGxCcDZ3LXc%7C0cr3-z0Zlf4%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a-/ALV-UjXXOZQ3mj-0VPdYKkmteQVCQpNv5HGP6N8DOTVWdh56oHf0BEc=s1920-c-rp-mo-ba3-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "We smelled this place from around the corner and followed our noses to absolute deliciousness followed by pure bliss! Additionally, Abbas took wonderful care of us. I'm wondering, how many times we can come back while we're visiting Lagos??"
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": false,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "David Powell",
  "reviewId": "Ci9DQUlRQUNvZENodHljRjlvT2pVelIyZENkbFF5ZEVKMWRXWllXRGwxWjNGQlRuYxAB",
  "reviewImageUrls": [],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT2pVelIyZENkbFF5ZEVKMWRXWllXRGwxWjNGQlRuYxAB!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CAIQACodChtycF9oOjUzR2dCdlQydEJ1dWZYWDl1Z3FBTnc%7C0crKA4in1M5%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a/ACg8ocJpjAxXHoEQZP5EMlKd6ARhFsgnf9dSIsRTNYCjte1A5GDp0A=s1920-c-rp-mo-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "Fantastic food. Really fresh, and very tasty! The poppadoms were almost a meal in themselves! The main dishes and the keema nam bread were delicious. Thoroughly recommended."
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": true,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "Marcus Lengfeld",
  "reviewId": "ChdDSUhNMG9nS0VJQ0FnTUNnaXBUUjlBRRAB",
  "reviewImageUrls": [
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90CYzVsX3Wb-msRa5FLWy2Crate5-bhtkqr0W9sLzMf-vlUFQ8IWp9zaQ-rhEOWyGqth0rQnmiQcMWTQPML_EwSsXFD-Y-puVm3_7upaRAaJZDWd2plbLKUFlijB_I4gV7OnbbLz",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90A0nIVjZRhBCdNH4Z_Iv7rhQ4dv8AbJ6FMMwuUzMBRBW-QutVGkvAsfMyuQq8BlvAIhmQLSen3MU2BbVl6TnlOmoeRemthJVfr3bjGZji24X9sL4YjNz74Z5hSa6yiXGy8pPaXD",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90CIDY01A5q0A4OMK_pHY3GuSrQrH7gw8jvZHmZ7e1XptY6UEe1Zn4MQW8LvLITcaM0DvPFyIqllxxZjiPFm2zvBNNRFYnd_OX4bDxMMZqwM9cbLX-QJ5DJYb-Q5OHeroeikfzU"
  ],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChdDSUhNMG9nS0VJQ0FnTUNnaXBUUjlBRRAB!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CIHM0ogKEICAgMCgipTR9AE%7CCgsIrKPMvQYQ8JfBXA%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a-/ALV-UjVNBjnbFjlZyxcI1Si4R6NeCIsT7nPYvuwQXNWyPSIUYdrY43dR=s1920-c-rp-mo-ba3-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "5 Star Indian Restaurant. Amazing tasty Food nice and friendly Staff and good Atmosphere. You will Need to chf k it out. We had Mango and korna chicken with naan bread and it was top 👍"
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": false,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "Sam Dixon",
  "reviewId": "Ci9DQUlRQUNvZENodHljRjlvT2kxNGNsVmxjM1F4ZVRSeGNXMVhSVjlGWjBKWmIxRRAB",
  "reviewImageUrls": [
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90APtUKf0Cmf4WTNxeEx1rZM0rlc07-ti0cZjHu1ZhUsrR-e_G7UYLc_s5jb-GcSsgQ8SiK8iohemZlJlMdZIsjUG3OIzqYccpQx6w-DAZsDFvTLu1jQb7bzqtR2rTnGq_05PrwQW2Z7zQP7"
  ],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT2kxNGNsVmxjM1F4ZVRSeGNXMVhSVjlGWjBKWmIxRRAB!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CAIQACodChtycF9oOi14clVlc3QxeTRxcW1XRV9FZ0JZb1E%7C0cRgvblQO-o%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a/ACg8ocIjTplLHQQ7BixYDCm7oAdyCY1m8QiJ3P8g-dZEFuISfrrbPQ=s1920-c-rp-mo-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "Abbas is a brilliant waiter and the food was supberb. Ive eaten at some amazing Indian restaurants and this place is up there!"
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": true,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "Rajiee M Shinde",
  "reviewId": "ChZDSUhNMG9nS0VJQ0FnSUNyd01DS1J3EAE",
  "reviewImageUrls": [
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90AesGs_tf6wUBI6OeGuXjQ8iSAGVTfYwS0chnEJznziLN_jmclEuOFprrF04741lLEUXqkYgim3KFN7ljee3Deo9qD_-LUvZkE7F4cGfmcupjQ9LDfnREKbztF--FSIlRbJuf8J1g",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90Av2yTjZMAGTYC7fjINV2GinDliHGjEukHwjP8Xr5kc9tlgU8f_QCIToXO4e3yqxPX5JMIwzkt-jq7s4cZD4uejjWIfXvbxOhdaJ2gemPfVcVYg0TpF_Vwf78mcD_-kAXat5DiP",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90BMENOazrjD3AYSufyqPI3GsuKHhI7USyTAkkzmE-VDseGJU6iw6CPABLx5X7XTYNeDFHwCxMUFQDy9h75N5vRoSkZ-tORZMX22By6ptPi5UPFYBTEPsEjb8mpaPTKVdD6BOT6_",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90AN8b45g1Xun0KptGOFQlnaV2adQ89Ul288TyP6HB4LNxMumc_GQfwL1xkZZUmnzdLDlgn-By9X4nV1I97k8PH0UuK9CZtO_ALo-jzT9kJWCtm6tqCa-xE-r-tx8tZSlOF-dvc",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90C6Q6id1BBuCs0MjdpyZd5edEfBDafQ0EKnhzckXiWq5MvoOUm1HtuzuT-t7O83T-EFiOInWLfL_Bgpbiyk5cDhmIE-5zgFNWns9-tC22MA4cTGSe0Uj_U2EXs_KSlBoFoZK1jM",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90D2mb2hLIOuj28jkyS2iIEuDknYuDPXZtASun4KE-N6IxIlN8u4cKuyNlzVvuEcidTTu-yjr4EFb0LXHLPBOT3ELu7bfq_arlTEQh21_4N_Vkxh4FMuHqIWjdHDRH5f2TFfjXgn",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90DdNabko14_DLjNgJoniUZf0I1Z6-sMkbNMpJ73kYDtIrJeAh1ZYp9HTwQaWvf3rxoecHaEOUdQW76xz_OM4AGBnSlpCfUAubzP2DB_28Du4-o1OHjyIFniX6d9r1dIX7N2NUmV9A",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90BXqjgxeuZgABGSAEM9EQ8QK4veQ60kqzMLx43IKR2hZRJ3K0lr5Ote8de3koe0BPsxB9IcMK81ck1SZ4PnUwjj9jAFQHfxA-83HbM5iI-v_yJ5oKagwNt54LO1aW5gnQlmxmgO",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90Bb-UayX-WkdoXMCQS1ih_kdymJktMZGtiqCYJVg-vPb1utoAS_MrjdHzmMa7DrsuZHNPrN0A1z0Q5G5ynBqKY8jyRd2UtbizbBdqS4Av91SCnX1Pu0tlxZfscvtON7wgfXx4bzHQ",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90BTUM3xUecMYP34t3Mn2wUWo4pu5_i0JunIsoefCezupJ4rZ6NuvjGLozkFfvHencVtOSdv4HfEDoiMZD6AYBwPmCQlErdhqbuvTeRmtsA4cTxcxOFPgJa3De9Wo7H0ubMocmqm",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90BxQUFy8vNK6pqdvMEaa9utRwSMOi2cAYDh8M2zLPdSkL9AciT4JgDLzQ6JJm9WmPHwQH1z5rrPpyFny2KjVw2FA3YRJuIjFqlQviRqrzCOHuNNXxLr-7qYGF_jWU1BpfkhFeUygA",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90Duoghk2cF_NfQJ6Ybt7940surlxjg-NwyeNyUhiGRFBr_ux8GekVpu9iYBLmvkJznv5j8ntIVW6B4EzxqqltO6wAaJIa_GKspb_zL7csiQNh8nUsZ5nuI0VuJK7glbO_f1lgzA",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90D0fYmON6mgROQT61fkOY2KbVfnvxvBft2Ry7JpF3QGRl0q4JVw4y6PCeRMz0dXvTrqQc7Ho7pfVtTdYl604ytAzlB8-BO9toTYUZ0aVB0gB1XKzgDPgI5r_KHZ7SeHx7sUY9wxAA",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90Bx8cC55TQLkAJjxk_QywkKpondFcjIzcK3hA_0JpwauD1LZq0vjNJtFBtD4_jozm3CJOjUOzlYN1SFxPZW_xj3d6dZaUr0hrYXih-anB2wkeuxK3Lvi078k9iwoRJAbyMJofYs",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90AwMUBaCZao0MQ9EaZpyQHkiWoa6oy94mRTWz9g0-5yU6yr-ojMt2AJy-veGAun-kHjfYsknx7IUqRJMC3eED7O1qTbZRNA83my_a4hwJ_bZf85vSApR6yaApcvgy_ablsSSZ7b"
  ],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChZDSUhNMG9nS0VJQ0FnSUNyd01DS1J3EAE!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CIHM0ogKEICAgICrwMCKRw%7CCgwI-buStAYQ6J6o-AE%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a/ACg8ocIToBqgZPyZJDu_5QWEANGL7CwFMGWU737YXMRZdAzH2pcyzuw=s1920-c-rp-mo-ba5-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "Amazing Indian food outside india. Loved the hospitality and the ambience. Great owners and wonderful staff. It was a surprise to find such a nice Indian restaurant in Lagos. A must go by everyone when in Lagos! Loved the prawn biryani, naan and dal makhani!"
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": true,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "Lindsay M",
  "reviewId": "Ci9DQUlRQUNvZENodHljRjlvT25sU1NWWklOSFZqUWxCeVFqTkdXSEpKWTNWaVZtYxAB",
  "reviewImageUrls": [],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT25sU1NWWklOSFZqUWxCeVFqTkdXSEpKWTNWaVZtYxAB!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CAIQACodChtycF9oOnlSSVZINHVjQlByQjNGWHJJY3ViVmc%7C0cXw8CMMYu-%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a/ACg8ocK2yKKyyv-bT_xHK-BL9V1aZ6FubCJSQrIWmzxTPqEdtEcP7g=s1920-c-rp-mo-ba4-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "10/10 food and service! Was very nice that they had air conditioning inside.\nThe portions are quite large, but the food was absolutely delicious. Glad we stopped in!"
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": false,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "Mandeep Multani",
  "reviewId": "ChdDSUhNMG9nS0VJQ0FnSUNPc3NlODN3RRAB",
  "reviewImageUrls": [
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90DIK6R6feNKUhcJ7F6gK5WFGBl3dInnDxXOo--dX2LNbBUugBwzyZcJht0bfcXE1WPTxak2IXAP8FSCWFW8mlPkfgVskuv1KPSm2bRgRxuok1FSvMjLEjDrP08_k3ASGnzq4Vg",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90A9E26liU0WQp7PwVQpmOAGBkUuGD0RP5IaqXA63Ld198GOJL5TaX-MZJfpWmdmz1DcLKDnVpKJWwXFtHyFT8M4c6UV0BXC4ifp5WaA5uw0NoSkPRyRi2EvPAqe02VRf0Nk_SoM3Q",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90C96pBrSWeKWjcAvhpFyuSoYUFOdIgy37ZmYnrySGifS_otN8zd0diNCVzlUefvS4lGoeo0EDvJ-kOIcJQ5_y9Z-0pM_XiZbfQIhJ66mZ2Gho3OadJprY_ZSVRENl7mF6x0OKXc",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90AZwvhmaEzCZN8c732pptDZVUfGKbzpBWwTNX9n2WANMcb5dkLRY3ByjKJBwoG8rFb1dkkgLjNtqUuS-EmxG1Kh6tfgIbXKeLKlvruG32GGuwXs2-ceEZLicyITyGgs0iC5lQGRwA",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90AvGVrnkX2GUc57DeTdkMMV3i45SLZ7iY-VNz6J8EeHbcxGVWOidO1S36MCu0_pzJ8Vm_2GKE3b4v8L66K8J0NTGwqaN-981SogmwoYFKR-7SSjd7bIcBqWqqhhALtjvRhrF0kT"
  ],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChdDSUhNMG9nS0VJQ0FnSUNPc3NlODN3RRAB!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CIHM0ogKEICAgICOsse83wE%7C0cOG9jiKAM4%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a-/ALV-UjVPgx_p6Vdxpgt0WFkHyue0s_wp7pkLVMjl39vLBO22MTa2NrA=s1920-c-rp-mo-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "Beautiful place,I recently dined at Spice Symphony, and it was an exceptional experience from start to finish. The ambiance is warm and inviting, with a perfect blend of modern and traditional Indian decor. The staff were incredibly attentive and provided excellent service throughout the meal."
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": true,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "TAMAR SHAMIR",
  "reviewId": "Ci9DQUlRQUNvZENodHljRjlvT2s1V1kxaHhNVjlsYkdOSE9VOXVVaTFIZVdGWFVGRRAB",
  "reviewImageUrls": [
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90BgQHiEqex0GWWLEclvsJXn2w1JcGu9LFz2A3eqsOuZvQ0IA2O2eSU9uQPtbazBelMWiA63nTaJ2sGiLhQkGlDbVoqdnKq6EEI1b7lIQyOfg1eTSCGWyoZ66wrGmqDeZv9l0y8WaIhneIE",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90DtXAAkKN_G_KAiT9c7o9BJrCT10uv00s_PB5s7_hRfuO5yEOA2rgtH8f-dEx44N2MX_7wKE-R4Mogg0tQWzDkutxG2UUdVU9GYOfrD2_joHGpJJWuwHCzkPxbyUUppJFgNvs9jDNhYy7E"
  ],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT2s1V1kxaHhNVjlsYkdOSE9VOXVVaTFIZVdGWFVGRRAB!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CAIQACodChtycF9oOk5WY1hxMV9lbGNHOU9uUi1HeWFXUFE%7C0cY8J0rhDEr%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a-/ALV-UjV72tLMqPlLogRj4foaaWZn8GgPn27R65R1pZzp4-9ZN68oUjXINQ=s1920-c-rp-mo-ba4-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "Very tasty vegan food, i loved it alot. Great service."
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": false,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "Eric Segal",
  "reviewId": "Ci9DQUlRQUNvZENodHljRjlvT25kUmJUUXlhRzE2TWxweFEweGpZbmQ2UlVORU1WRRAB",
  "reviewImageUrls": [],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT25kUmJUUXlhRzE2TWxweFEweGpZbmQ2UlVORU1WRRAB!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CAIQACodChtycF9oOndRbTQyaG16MlpxQ0xjYnd6RUNEMVE%7C0cdBIb4Z5Vo%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a/ACg8ocKkFiNsb4fRxSimSjrayPWsUQ9BNObNE6i-f_-FK70FToE83w=s1920-c-rp-mo-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "This place is great. Now here for second night in a row. We are whole food plant based, SOS free, and this place made modifications for us so that the food would be compliant, or at least as much as possible. So delicious. I’d recommend this restaurant to anyone, and especially wfpb sos free folks! They have a menu page titled “Vegan”."
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": false,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "Chloe",
  "reviewId": "Ci9DQUlRQUNvZENodHljRjlvT2pFelNWSTVaMkZyWXpSdFZUUXphVGxwU2xwSVFrRRAB",
  "reviewImageUrls": [],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT2pFelNWSTVaMkZyWXpSdFZUUXphVGxwU2xwSVFrRRAB!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CAIQACodChtycF9oOjEzSVI5Z2FrYzRtVTQzaTlpSlpIQkE%7C0cVWIARTY9k%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a/ACg8ocIkUuek_e5d4njjN_1bhvKHyhf1a3X_9hsYrQ2aYMK-aE-Q3A=s1920-c-rp-mo-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "Went into this lovely Indian restaurat recently. I have a peanut allergy and the staff and kitchen went above and beyond to make me a curry that doesn't contain any peanuts. Highly recommend this restaurant. Food and staff are amazing"
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": true,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "Grace King",
  "reviewId": "ChdDSUhNMG9nS0VJQ0FnSURMNzgzZ213RRAB",
  "reviewImageUrls": [
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90BVox-IhGiC6hqvXGDEQH1_QFA5gPNLYNRXX8BiK3kvuqZURGq8fPJSmqJYITJStbYemLNrxy9UuFyVgZ_P9RukdG4m7pm3ZbhtwwcXA-DxkdiX_27vP8fcYIjrHjr0EMCK_ItP"
  ],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChdDSUhNMG9nS0VJQ0FnSURMNzgzZ213RRAB!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CIHM0ogKEICAgIDL783gmwE%7CCgwI-6aQtAYQqPrSyAI%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a/ACg8ocIrlpYko2AclKz8apxaQW188rE7yyihWXZv3pQuIm6LHKQj4g=s1920-c-rp-mo-ba3-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "We stumbled upon this Indian restaurant at the heart of Lagos completely by chance - but it was exactly what we were all craving. With a large menu with many options for vegetarians and meat eaters, the food was absolutely delicious (as was the wine). We came on a Wednesday evening when the restaurant was reasonably empty but can imagine it must get busy at the weekends. Thank you so much for having us! I asked for medium spice and felt that it could have been slightly spicier, but it still tasted amazing."
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": false,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "Sakshi Panjeta",
  "reviewId": "ChdDSUhNMG9nS0VJQ0FnTUN3aWVQaGpRRRAB",
  "reviewImageUrls": [
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90DUHnob8nOXaXtnOytmDVPBzPL91U8oU5vJMka-H20xEzq5A_2zQ9rd6YKGrF_LxMABM4isdS398m4HZYQpTeEfOiX9fOiZZoG1PMFyNs6YhqsDxVMhW-N4Jrxbi_sHJDykZ1zQ",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90CJSTmblKKRXk5MS4DE_Rq0VYSFdzDcM5q6q37_Vg6qNd-j4jMSDILt95mnRvwfJd9hnKls8V-h8W5enfl3yodPE1DeJnclDg5-UL_4G6XSqBF1W7kzvIkvPkx6wMbk2HvbnIhrZQ",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90CdNtDhWRwgyYKldfr_68eDJDNkjP-RjNQNCiTq8bNVFx7FD0_bCbNuSh4qeCBpW3GNghLYmsSVPKRZtMJsci7-bxWKOxzRlknBEjXPLaEsMydgLMkY4fG93lD_ttwMONexRnBN"
  ],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChdDSUhNMG9nS0VJQ0FnTUN3aWVQaGpRRRAB!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CIHM0ogKEICAgMCwiePhjQE%7CCgsIveTrvgYQ-OmfKw%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a/ACg8ocJwg5WjcTkkha35HQg_wyDzMHmfumITkwVN8wPvwdEY-sjW4m0=s1920-c-rp-mo-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "Best food in lagos 👍 staff is very friendly   Beautiful interior , highly recommended  must try  mango lassi , masala papadum , chicken tikka masala  and pistachio kulfi"
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": true,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "T W",
  "reviewId": "ChZDSUhNMG9nS0VJQ0FnSUNodVBTTVpBEAE",
  "reviewImageUrls": [
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90B6Tu12rHSEld-G8bxg-JE7ZNmpIi4vSeeYA-Hj-CiJblKIUr-l27UMnevHy5pBwkmicIiPt5mQYFPsczCKlQcTQ3lEt13JG6g9vG7t0JDXO9lt_stlUn_HDfZXGdoNb-zMA_nTBg",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90CsS9MvOTYLktl9SpI13BpXAu0meser_XPNPl1EHmPCbb_qpfYK5bF_E-E288fgHr5MNmd1KZxgEg5b34PgLPwELTQAEZb9Q9O4thIjGo_luw3kzyzOYaEbfL1DfXEFzzQwSupD",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90CP1TvPga4ZAqK2rTzvj8JJxk7lOy_9CKQwgH51jvmD3S52s3XomKqkXaftY3BVwec5Txdfaanmx92XufzQ6FD1xoZ18pzm5cK2BGX5nDeLX3xeCSxCLgdD94U3lLMcaSObsP2K1g",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90BX0voT6XkxY2zjegcMpVEddZ2u5cswVn17aUFYyI4CiK9XEQkNgIWtHO0itMQaJdnBiAcW-LrVaUMwF2dZNFZcS-PM6kqodKkfjfmA43JvStAEYwLUyAN3_v7AUX4gvTEO3l8q"
  ],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChZDSUhNMG9nS0VJQ0FnSUNodVBTTVpBEAE!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CIHM0ogKEICAgIChuPSMZA%7CCgsIj_z6ngYQoLuEQQ%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a/ACg8ocKVKXdkrXFtPLQrqWyN8-QKkQ9Y2ESeyE3PduepgqkHQ697Wg=s1920-c-rp-mo-ba2-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "Royal Indian Cuisine is one of the best Indian restaurants I have ever been to.  Prices were very reasonable.  For 38 euro we had 1 starter, 2 beer, 2 mains, a side of rice, and 2 servings of Naan bread. Staff was friendly and very knowledgeable about the dishes.  Highly recommended."
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": false,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "Srikanth Subramani",
  "reviewId": "ChdDSUhNMG9nS0VJQ0FnSUMxZ3J5b2hRRRAB",
  "reviewImageUrls": [
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90AIBfAtM0f1Bbf3sU1ih9HU2YPrXWSyAun3ep2aI0_Tm0BJxIiYwNKtvilQOxHTfM1Tokm4ZkIP-A-Bvwh6m8r_6SbyVBNPK2KKBTdbQiXwnyhbGN__BQRUXnWySTSZBvE70KFp"
  ],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChdDSUhNMG9nS0VJQ0FnSUMxZ3J5b2hRRRAB!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CIHM0ogKEICAgIC1gryohQE%7CCgwI8dynrAYQgKne4QI%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a/ACg8ocIUlt-eiC_uXxcQKO_nFLPRiF4Y_HhXMeoovId6kTA7brAgPQ=s1920-c-rp-mo-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "A Regal Feast at \"Royal Indian Cuisine\"\n\nRoyal Indian Cuisine, a five-star sanctuary for aficionados of Indian flavors, enchants diners with its exceptional culinary offerings and impeccable service. From the moment you step into this regal establishment, it's clear that you're in for a dining experience that transcends the ordinary.\n\nThe crowning glory of Royal Indian Cuisine is undeniably its gastronomic treasures—a majestic exploration of India's diverse and vibrant culinary landscape. From aromatic biryanis to tantalizing curries, each dish is a regal creation, a testament to the chef's commitment to authenticity and perfection. Every bite is a journey through the rich tapestry of Indian spices, creating a culinary experience that is nothing short of extraordinary.\n\nThe service at Royal Indian Cuisine is a seamless fusion of attentiveness and professionalism. The knowledgeable staff guides diners through the extensive menu with precision, offering recommendations that align perfectly with individual tastes. From the moment of seating to the final farewell, the dedicated waitstaff ensures that every aspect of the dining experience is executed with grace and flair.\n\nWhile Royal Indian Cuisine unquestionably earns its five-star status for its exceptional food and service, it's important to note that the opulence comes with a premium. Some menu items may be on the higher end in terms of pricing, positioning the restaurant as a destination for special occasions or those seeking a lavish culinary adventure.\n\nIn conclusion, Royal Indian Cuisine is a culinary jewel that beckons those who appreciate the finer nuances of Indian cuisine. The unforgettable flavors and impeccable service elevate it to a five-star realm, albeit one where luxury is accompanied by a discerning price point. For those in pursuit of a regal gastronomic journey, Royal Indian Cuisine stands as a must-visit destination, promising an experience that is both majestic and memorable.\n\nFin"
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": true,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "sidharth singh",
  "reviewId": "Ci9DQUlRQUNvZENodHljRjlvT2pZelJYbHpPVnBNVGxJNGQwdHZTbXRTT1hsUU5VRRAB",
  "reviewImageUrls": [
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90C5pqhyeKMoTI8-0zi0yof-8btStYQwl07iylcza9ivyHTJd8YjSUTJz8Haf_hmejSoPgP9s0bYk0TdwgIImLpp6oWnhDPyDvNqXkcD9g4jr7Zmtnc5kvWSCrN4mcJggeSvLfYnWcbDJxE",
    "https://lh3.googleusercontent.com/geougc-cs/AB3l90Bnfbjlnai1Vi8DrYZUaEoe0_TmGjtZ7Bq0cVnmPbKyDffR29D6L4ZTD0dJqgSUFC7Tf4Ee_-27_G4jZW7_GtV-AWJSAGEYhdhxZvC4B86AObvPmbWqFJDjNQ4C-IVX_UFc0FrYCqwiEU4K"
  ],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT2pZelJYbHpPVnBNVGxJNGQwdHZTbXRTT1hsUU5VRRAB!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CAIQACodChtycF9oOjYzRXlzOVpMTlI4d0tvSmtSOXlQNUE%7C0cI4P8e2gMp%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a-/ALV-UjWaoEFH8mQoK-7wPcs7hsCShfNdWCHcMn7mnsT8HsuFNUkd9RHS=s1920-c-rp-mo-ba5-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "Good food with great location in the heart of the Old Town."
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": true,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "David “Tohund” WILEMAN",
  "reviewId": "ChdDSUhNMG9nS0VKcVRsNFhVMmZQU2h3RRAB",
  "reviewImageUrls": [],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChdDSUhNMG9nS0VKcVRsNFhVMmZQU2h3RRAB!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CIHM0ogKEJqTl4XU2fPShwE%7CCgwI1rf8wQYQuNqj1gI%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a/ACg8ocKT1Vib4XVlzw_yL50CegReISGodj710tN3RQKKSfdk7xEM2A=s1920-c-rp-mo-ba3-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "We have to say this is one of the nicest Indian restaurants we have eaten in. You are welcomed by door staff who present themselves in a most professional way. Staff get you seated and when you are ready take your order and occasionally check to see if all is ok. We had several dishes vegetarian and meat and they were fantastic.\nTo avoid disappointment pre book and enjoy a wonderful evening."
},
{
  "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgS1h7Xb2ll3B_pyPaEtX8b9uWdtWOWxFYUwbq=w408-h544-k-no",
  "isLocalGuide": true,
  "location": {
    "lat": 37.1022599,
    "lng": -8.6737126
  },
  "name": "Thomas Murphy",
  "reviewId": "Ci9DQUlRQUNvZENodHljRjlvT214YWNuTjROemhKYzFwNVdtOXlUazA0WjBWc2MyYxAB",
  "reviewImageUrls": [],
  "reviewUrl": "https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT214YWNuTjROemhKYzFwNVdtOXlUazA0WjBWc2MyYxAB!2m1!1s0x0:0x4b10e8307a5577fa!3m1!1s2@1:CAIQACodChtycF9oOmxacnN4NzhJc1p5Wm9yTk04Z0Vsc2c%7C0ce4ujXdW8X%7C?hl=en",
  "reviewerPhotoUrl": "https://lh3.googleusercontent.com/a/ACg8ocLC2C88jgqCUB6pCxnAMPP4boaYDOaQBbmr-IpNKRpCsoVuAg=s1920-c-rp-mo-ba2-br100",
  "stars": 5,
  "title": "Royal Indian Cuisine Lagos",
  "text": "Absolutely delicious, I have been here twice for dinner in Lagos. Great service with an option for blankets if you get cold which was great for my girlfriend.\n\nHighly recommend!"
}],

    // Reviews
    rating: 4.6,
    reviewCount: 850,

    // Section titles
    sectionTitles: {
        map: {
            en: "Find Us",
            pt: "Encontre-nos"
        },
        mapSubtitle: {
            en: "Visit us in Lagos for authentic Indian cuisine.",
            pt: "Visite-nos em Lagos para cozinha indiana autêntica."
        },
        menuSection: {
            en: "Authentic Indian Menu",
            pt: "Menu Indiano Autêntico"
        },
        menuSectionSubtitle: {
            en: "Traditional dishes that bring the flavors of India to your table",
            pt: "Pratos tradicionais que trazem os sabores da Índia à sua mesa"
        }
    },

    // Features settings
    features: {
        logoSize: {
            hero: 2.16,
            navbar: 0.9
        }
    },
};

export default restaurantConfig;